
import accountApi from '@/api/account'
const account={
    actions:{
        isTenantAvailable({state},tenancyName){
            state
            return accountApi.isTenantAvailable(tenancyName)
        }
    }
}
export default account